export default "__VITE_ASSET__5o3x2hXA__"